var angular = require('angular')
angular.module('promemoria').component('auiBreadcrumbs', {
  template: require('./breadcrumbs.html'),
  bindings: {
    item: '@',
    loaded: '='
  },

  controller: function ($scope, $element, $attrs, $http, ENDPOINT_SEARCH, LINKS) {
    var ctrl = this
    ctrl.breadcrumbs = []
    ctrl.LINKS = document.location.origin + document.location.pathname
    ctrl.loaded = false

    ctrl.$onInit = function () {
      $http.post(ENDPOINT_SEARCH, {
        'table': 'data',
        'query': {
          'id': parseInt(ctrl.item, 10),
          'table': 'ca_objects'
        }
      })
      .then(function (data) {
        if (data.data.count <= 0) { return }
        ctrl.name = data.data.data[0].preferred_label
        if (data.data.count > 0) {
          var currentNode = data.data.data[0]
          if (currentNode.parent !== 0) { // Risalgo la gerarchia
            $http.post(ENDPOINT_SEARCH, {
              'table': 'data',
              'query': {
                'id': {'$in': currentNode.parent_path.split('/').map(function (e) { return parseInt(e, 10) })},
                'table': 'ca_objects'
              },
              'fields': {'id': 1, 'preferred_label': 1}
            }).then(function (result) {
              // Aggiungo i padri all'albero
              var order = currentNode.parent_path.split('/')

              for (var i = 0; i < result.data.data.length; i++) {
                if (result.data.data[i].id === parseInt(order[0], 10)) {
                  ctrl.title = result.data.data[i].preferred_label
                }
                ctrl.titleId = result.data.data[i].id
              }
              order.shift()
              var new_result = []

              if (order.length > 0) {
                order.forEach(function (elem) {
                  for (var i = 0; i < result.data.data.length; i++) {
                    if (result.data.data[i].id === parseInt(elem, 10)) {
                      new_result.push({
                        'id': result.data.data[i].id,
                        'preferred_label': result.data.data[i].preferred_label,
                        'table': result.data.data[i].table
                      })
                    }
                  }

                  ctrl.loaded = true
                })
              } else {
                ctrl.loaded = true
              }

              if (result.data.count > 0) {
                for (let i = 0; i < new_result.length; i++) {
                  ctrl.breadcrumbs.push(new_result[i])
                }
                ctrl.breadcrumbs.push(currentNode)
              }
            })
          } else {
            ctrl.title = data.data.data[0].preferred_label
            ctrl.titleId = data.data.data[0].id
            ctrl.loaded = true
          }
        }
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/js/components/breadcrumbs/breadcrumbs.js